import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	emptyStateTitleNonFinal: {
		id: 'periscope.common.empty-state.empty-state-title-non-final',
		defaultMessage: 'No work suggestions',
		description: 'Text as title when no work suggestions are available',
	},
	emptyStateDescriptionPrimaryNonFinal: {
		id: 'periscope.common.empty-state.empty-state-description-primary-non-final',
		defaultMessage: 'We didn’t find any tasks ready for you to pick up.',
		description: 'Text as description when no work suggestions are available on the first line',
	},
	emptyStateCheckAgainLaterNonFinal: {
		id: 'periscope.common.empty-state.empty-state-check-again-later-non-final',
		defaultMessage: 'Come back later and check again.',
		description:
			'Text as description when no work suggestions are available to suggest user check again later',
	},
});
